import { EMPTY, Observable } from 'rxjs';
import { dynamicEnv } from 'environments/dyn-env';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EnvParams {
  private static params: any = {};

  public static get(key: string): string {
    return EnvParams.params[key];
  }

  public init(): Observable<any> {
    // Flatten dynamic environment structure into flat object.
    let entries = Object.entries(dynamicEnv).map(([key, value]) => ({key, value}));
    while (entries.length > 0) {
      const {key, value} = entries.shift();
      if (typeof value === 'object') {
        entries.push(...Object.entries(value).map(
          ([subkey, value]) => ({key: `${key}.${subkey}`, value: value})
        ));
      } else {
        EnvParams.params[key] = value;
      }
    }
    
    console.dir(EnvParams.params);
    return EMPTY;
  }
}
